module.exports = __webpack_public_path__ + "resources/img/img_main_bnr_ahnlab_marketplace.9d08461d2be964e1463e4d3712e1d600.png";